module.exports = __webpack_public_path__ + "img/njzdl-bg.183f9a84.png";